import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../base_svg-icon/component';
import './styles/styles.scss';

class GoogleBooksPreview extends Component {
  constructor(props) {
    super(props);

    this.googleViewerCanvasRef = React.createRef();
    this.onLoad = this.onLoad.bind(this);
    this.goToNextPage = this.goToNextPage.bind(this);
    this.goToPreviousPage = this.goToPreviousPage.bind(this);
  }

  componentDidMount() {
    this.fetchGoogleApi();
  }

  /**
   * Inject the google api script when it's needed
   */
  fetchGoogleApi = () => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.google.com/books/jsapi.js';
    script.onload = this.initialize;
    document.head.appendChild(script);
  };

  /**
   * Initialise the google books api library
   */
  initialize = () => {
    window.google.books.load({ language: 'nl' });
    this.waitForGoogle();
  };

  /**
   * Keep trying to load the google api
   * may not take longer than 10 * 200ms
   *
   * @param {number} attempt
   */
  waitForGoogle = (attempt = 0) => {
    if (!!google.books.DefaultViewer) {
      this.viewer = new google.books.DefaultViewer(this.googleViewerCanvasRef.current);
      this.viewer.load(`ISBN:${this.props.sku}`, null, this.onLoad);
    } else {
      const maxAttempts = 10;
      if (attempt < maxAttempts) {
        setTimeout(() => {
          this.waitForGoogle(attempt + 1);
        }, 200);
      }
    }
  };

  onLoad() {
    this.viewer.resize();
  }

  goToNextPage() {
    this.viewer.nextPage();
  }

  goToPreviousPage() {
    this.viewer.previousPage();
  }


  render() {
    return (
      <div className="pdfBookPreview">
        <div className="pdfbook">
          <div className="pdfbook-top">
            <div className="pdfbook-top--close" onClick={this.props.closePreview}>
              <Icon
                name="ico-error"
              />
            </div>
          </div>
          <div className="pdfbook-body">
            <div className="pdfbook-navigation prev">
              <button
                className="arrow arrow-prev"
                onClick={this.goToPreviousPage}
              ></button>
            </div>
            <div className="googlebook-content">
              <div className="googlebook-content-book" ref={this.googleViewerCanvasRef} />
            </div>
            <div className="pdfbook-navigation next">
              <button
                className="arrow arrow-next"
                onClick={this.goToNextPage}
              ></button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// proptypes
GoogleBooksPreview.propTypes = {
  sku: PropTypes.string,
  closePreview: PropTypes.func,
};

export default GoogleBooksPreview;
